module.exports = __webpack_public_path__ + "static/media/user_icone.914173c0.png";